var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountNumberHelpIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EFEFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7415 26V24.146H18.4135C21.6355 21.716 23.6695 19.736 23.6695 17.522C23.6695 15.128 21.6355 13.814 19.3135 13.814C17.6395 13.814 15.9475 14.462 14.8855 15.74L16.1095 17.126C16.8655 16.262 17.9455 15.686 19.3495 15.686C20.4475 15.686 21.5275 16.262 21.5275 17.522C21.5275 19.25 19.7095 20.816 15.0475 24.344V26H23.7415Z",
    fill: "#3532F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountNumberHelpIcon2);
export default __webpack_public_path__ + "static/media/AccountNumberHelpIcon2.e6681bb4672c9de4761f855be72b0e8d.svg";
export { ForwardRef as ReactComponent };